export default class DashboardRCCEDefinition {
    constructor(id, week) {
        this._id = id;
        this._week = week;
    }

    get id() {
        return this._id;
    }

    get week() {
        return this._week;
    }
}
